<template>
  <div @click.stop="" class="file-contorl" v-if="show">
    <div v-if="control.oneFlag" class="single">
      <template v-if="control.displayType !== 'card'">
        <span v-tip class="can-click">
          {{ strVal }}
        </span>
      </template>
      <template v-else>
        <el-tooltip
          class="item"
          effect="dark"
          :content="_.keys(file).includes('name') ? file.name : ''"
          placement="bottom"
        >
          <div @click="preview" v-if="canFileView" class="image">
            <img
              v-if="!['word', 'excel', 'ppt', 'pdf'].includes(getType(file.type))"
              :src="compressedUrl"
              style="width: 28px; height:28px"
            />
            <svg-icon v-else :icon-class="getType(file.type)" style="font-size: 24px;"></svg-icon>
          </div>
          <div v-else class="image">
            <svg-icon icon-class="detail_common-file" style="font-size: 22px"></svg-icon>
          </div>
        </el-tooltip>
      </template>
      <span class="operation">
        <i v-show="canFileView" class="el-icon-view icon" @click="preview()"></i>
        <i type="text" class="el-icon-download icon" @click="download()"></i>
      </span>
    </div>
    <div v-else class="multiple">
      <div class="files" v-if="control.displayType === 'card'">
        <div v-for="(item, index) in localFiles" :key="index">
          <el-tooltip
            class="item"
            effect="dark"
            :content="_.keys(item).includes('name') ? item.name : ''"
            placement="bottom"
          >
            <div
              v-if="item.canPreview"
              @click="previewPic(item)"
              style="display: flex;"
              class="image"
            >
              <img
                v-if="!['word', 'excel', 'ppt', 'pdf'].includes(getType(item.type))"
                :src="item.url"
                style="width: 28px"
              />
              <svg-icon v-else :icon-class="getType(item.type)" style="font-size: 24px"></svg-icon>
            </div>
            <div v-else class="image">
              <svg-icon icon-class="detail_common-file" style="font-size: 22px"></svg-icon>
            </div>
          </el-tooltip>
        </div>
      </div>
      <span
        @click="showFilesInDialog"
        class="can-click-multiple text-right"
        :class="{ 'file-special': control.displayType !== 'card' }"
        v-tip
      >
        {{ strVal }}
      </span>
    </div>
    <file-preview ref="filePreview"></file-preview>
    <file-history ref="fileHistory"></file-history>
  </div>
</template>
<script>
import { getFileType, getCompressedUrl } from "@/utils/common"
import { loadingService } from "@/utils/ui"
import { download } from "@/utils/aliOss"
import { url_prefix } from "@/utils/uploadFile"
import FilePreview from "@/components/BaseComponents/FilePreview"
import FileHistory from "@/components/Sheet/DetailDialog/DataDetail/FieldItem/FileHistory"
import {downloadAttachment} from "@/api/userCenter/file";
import {fileWatermark} from "@/api/sheet/sheetData";
export default {
  name: "file-control",
  components: { FileHistory, FilePreview },
  data() {
    return {}
  },
  props: {
    files: Array,
    strVal: String,
    watermark: String,
    control: Object, // {displayType:"card, list(普通字符串)", oneFlag}
    sheetData: Object
  },
  computed: {
    show() {
      return !this._.isEmpty(this.files)
    },
    file() {
      return this.files?.[0] || {}
    },
    canFileView() {
      let result = false
      if (this.file && !this._.isEmpty(this.file)) {
        result = this.canPreview(this.file.type)
      }
      return result
    },
    compressedUrl() {
      if (this.file && !this._.isEmpty(this.file)) {
        return getCompressedUrl(url_prefix + this.file.path)
      } else {
        return ""
      }
    },
    // 将文件压缩一下在工作表里展示
    localFiles() {
      return this.files.map(({ name, type, path }) => ({
        url: getCompressedUrl(url_prefix + path),
        canPreview: this.canPreview(type),
        name,
        type,
        path
      }))
    }
  },
  methods: {
    getType: getFileType,
    canPreview(type) {
      return this.getType(type) !== null
    },
    previewPic(file) {
      let fileInfo = {
        url: url_prefix + file.path,
        type: this.getType(file.type),
        name: file.name
      }
      this.$refs.filePreview.preview(fileInfo, this.files,this.watermark)
    },
    preview() {
      if (this.canPreview(this.file.type)) {
        this.previewPic(this.file)
      }
    },
    download() {
      if(this.control.aw){
        fileWatermark(this.file.id);
        this.$message.success("下载任务已提交，请等待消息通知！")
      }else{
        downloadAttachment(this.file.id)
        const loadingInstance = loadingService()
        download({ objectName: this.file.path, downloadName: this.file.name }).finally(() => {
          loadingInstance.close()
        })
      }
    },
    showFilesInDialog() {
      this.$refs.fileHistory?.open({ filesForShow: this.files,watermark:this.watermark,control:this.control })
    }
  }
}
</script>
<style lang="scss" scoped>
.file-contorl {
  display: flex;
  align-items: center;
  width: 100%;
  .single {
    display: flex;
    width: 100%;
    .can-click {
      color: $color-main;
    }
    .operation {
      margin-left: auto;
      opacity: 0;
      display: flex;
      align-items: center;
      .icon {
        & + .icon {
          margin-left: 3px;
        }
        &:hover {
          color: $color-main;
        }
      }
    }
    &:hover {
      .operation {
        opacity: 1;
      }
    }
  }
  .multiple {
    display: flex;
    width: 100%;
    .files {
      display: flex;
      align-items: center;
      margin-right: 6px;
    }
    .can-click-multiple {
      color: $color-main;
      font-weight: normal;
      cursor: pointer;
      margin-left: auto;
    }
    .text-right {
      text-align: right;
    }
  }
  .image {
    margin-right: 2px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #eaecf0;
    border-radius: 2px;
    &:hover {
      width: 31px;
      height: 31px;
      background-color: #e8e9f0;
    }
  }
}
</style>
